var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('must-have-toggle-intern',{attrs:{"product":_vm.product,"loading":_vm.loading},on:{"markAsMustHave":_vm.markAsMustHave,"markAsnotMustHave":function($event){return _vm.markAsnotMustHave()}}})}
var staticRenderFns = []

export { render, staticRenderFns }